import React, { useEffect, useState } from "react";
import { Typography as T, Container } from "@material-ui/core";
import { appAxios } from "fd-react/Components/Axios";

export const RefundCancellationRefund = () => {
  const [additionalCancellationPolicy, setAdditionalCancellationPolicy] =
    useState();

  useEffect(() => {
    getCancellationPolicy();
  }, []);

  async function getCancellationPolicy() {
    try {
      const getCancellationPolicyResponse = await appAxios(
        "/api/settings/getCancellationAndRefundPolicy",
        {
          baseURL: "",
        }
      );
      if (getCancellationPolicyResponse.data?.success) {
        const privacyPolicy = getCancellationPolicyResponse.data?.result
          ? getCancellationPolicyResponse.data.result
          : undefined;
        setAdditionalCancellationPolicy(privacyPolicy);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  }
  return (
    <Container>
      <div className="py-5">
        <T variant="h5">Refund, Cancellation and Return Policy</T>
        <T>
          <br />
          <br />
          Every Product/Service sold on our website will contain a refund and
          cancellation policy mentioned specifically for that product/service.
          We offer various travel-related products and services and every
          product might have different cancellation/refund policies. And these
          cancellation and refund policies are provided by the supplier of that
          service/product. There are some products/servies which are not sold
          online ant the prices displayed on the website are tentative prices.
          Such products will not be sold online and customer will enquire and
          purches those products offline. Cancellation and refund policies for
          such products will be provided offline.
          <br />
          <br />
          We are pure agent in every transaction happing between the
          customer/user of this website and the supplier. We only earn
          commission/markup/booking fee/convenience fee. In case of every
          transaction occuring on our website, we are only action as a
          medium/middle-man.
          <br />
          <br />
          Products/Servies offered on our website are third-party products and
          services. We are just a booking engine/platform which allows the users
          of this website to book/purchase products/services online.
          Fulfillment of services has to be done by our suppliers.
          <br />
          <br />
          We reserve the right to deduct our service charge/handling fee/
          convenience fee on the refund amount. 
          <br />
          <br />
          If any airline/hotel/tour company/service provider/supplier fails to
          provide the refund amount/service to the users of this website then we
          will not be liable for providing the amount for the service/product.
        </T>
        <T>
          <br />
          <br />
          <div
            dangerouslySetInnerHTML={{ __html: additionalCancellationPolicy }}
          ></div>
        </T>
      </div>
    </Container>
  );
};
export default RefundCancellationRefund;
